import { Controller } from "@hotwired/stimulus"
import { showSystemToast } from "../utils/system_toast"

// The task pane's ••• menu (task_panels/_panel). detail-modal moves it out of
// the pane and up beside the sidebar's own buttons, so it is its own
// controller rather than part of task-pane. Pin is the shared pin button;
// copying happens here; Duplicate, Send to list and Delete are the outline
// row's own actions, asked for through the same window event the pane's
// details use (jane:task-pane-action) and shown only where that row is on
// screen. Elsewhere (the board, mind map, galaxy) "Open in list" stands in.
export default class extends Controller {
    static values = { taskId: Number, link: String, text: String }

    connect() {
        const probe = { taskId: this.taskIdValue, handled: false }
        window.dispatchEvent(new CustomEvent("jane:task-pane-probe", { detail: probe }))
        this.element.classList.toggle("is-detached", !probe.handled)
    }

    copyLink() {
        this._copy(this.linkValue, "Link copied")
    }

    copyText() {
        this._copy(this.textValue, "Task text copied")
    }

    rowAction(e) {
        const detail = { taskId: this.taskIdValue, action: e.currentTarget.dataset.paneAction, handled: false }
        window.dispatchEvent(new CustomEvent("jane:task-pane-action", { detail }))
    }

    _copy(text, message) {
        if (!text || !navigator.clipboard) return
        navigator.clipboard.writeText(text)
            .then(() => showSystemToast(message, { level: "success", duration: 2000 }))
            .catch(() => showSystemToast("Could not copy", { level: "warning", duration: 3000 }))
    }
}
